<template>
    <div class="web_index">
        <div class="web_title">
            <div class="web_title_content">

            </div>
        </div>
        <div style="width: 100%;height: 80px">
        </div>

       名片
      姓名：<input type="text" v-model="name"><input type="button" value="提交" @click="search()">
      <div v-for="item in resultList" :key="item.id">
        <div style="padding: 20px;">
          <div>id:{{item.id}}</div>
          <div>{{item.name}}</div>
          <div>{{item.department}}</div>
          <div>{{item.job}}</div>
          <div><a :href="baseUrl+'/api/mini_program_redirect/card?id='+item.id" title="如是pc，需要打开微信后点击">
            点这里打开小程序
          </a></div>
          <div>链接：{{baseUrl+'/api/mini_program_redirect/card?id='+item.id}}</div>

        </div>

      </div>

    </div>
</template>

<script>

    import cardService from '../../service/CardService'

    export default {

        name: 'Index',
        data() {
            return {
                name: '',
              resultList: [],
                baseUrl:window.BASE_URL
            }
        },
        methods: {
            search() {
                let that = this
              // alert(that.name)
              cardService.getList(this,{name:that.name},(res)=> {
              this.resultList=res.data

              })
                // that.jumpType = type


            },




        },
        mounted() {


        },
        updated() {

        }
    }
</script>


<style scoped="page">
    .web_index {
        width: 100%;
        background-color: #F0F4F5;
    }

    .web_title {
        width: 100%;
        height: 80px;
        background-color: #ffffff;
        position: fixed;
        top: 0;
        z-index: 1000;
    }

    .web_title_content {
        width: 1290px;
        height: 80px;
        margin: auto;
        position: relative;
    }

    .title_img {
        margin-left: 40px;
        margin-top: 18px;
    }

    .title_content {
        height: 80px;
        position: absolute;
        right: 45px;
        top: 0;
    }

    .title {
        float: right;
        height: 80px;
        line-height: 80px;
        font-size: 18px;
    }

    .title_red {
        float: right;
        height: 70px;
        line-height: 80px;
        font-size: 18px;
        border-bottom: 2px solid #cd001b;
        color: #000000;
    }

    .column_div {
        width: 1210px;
        height: 540px;
        position: fixed;
        top: 110px;
        left: calc(50% - 605px);
    }

    .column {
        width: 180px;
        /*height: 540px;*/
        background-color: #535353;
    }

    .web_content {
        width: 1210px;
        margin: auto;
    }

    a {
        text-decoration: none
    }

    .column_name {
        height: 54px;
        line-height: 54px;
        font-size: 14px;
        text-align: center;
        color: #ffffff;
    }

    .column_name_red {
        height: 54px;
        line-height: 54px;
        font-size: 14px;
        text-align: center;
        color: #ffffff;
        background-color: #EE534B;
    }

    .content_title {
        margin-left: 30px;
        padding-top: 60px;
    }

    .content_img {
        margin-left: 30px;
        margin-top: 40px;
    }

    .content {
        width: 1010px;
        background-color: #ffffff;
        margin-left: 200px;
    }

    .content_type {
        /*margin-top: 20px;*/
        position: relative;

    }

    /*.content_one {*/
        /*margin-left: 30px;*/
        /*margin-right: 30px;*/
        /*margin-top: 40px;*/
        /*font-size: 16px;*/
        /*color: #323232;*/
    /*}*/

    .content_one,.content_two {
        margin-left: 30px;
        margin-right: 30px;
        margin-top: 30px;
        font-size: 14px;
        color: #323232;
        line-height: 22px !important;
    }

    .content_two img{max-width: 950px;}

    .content_three {
        margin-left: 30px;
        margin-top: 60px;
        margin-bottom: 60px;
        font-size: 14px;
        color: #323232;
    }

    .content_erweima {
        position: absolute;
        right: 30px;
        bottom: 48px;
    }

    .content_erweima_title {
        float: left;
        font-size: 14px;
        color: #323232;
        width: 210px;
    }

    .content_erweima_png {
        float: left;
    }


    .web_bottem {
        background-color: #2E3139;
        width: 100%;
        height: 120px;
        font-size: 16px;
        color: #C4C4C4;
        line-height: 120px;
        text-align: center;
    }


</style>



// WEBPACK FOOTER //
// src/components/web/Card.vue